import VModal from '@/vuetify_custom/v-modal_v1'
import VForm from '@/vuetify_custom/v-form'
import FileUploader from '@/views/components/file/uploader';
import EditAttachments from '@/views/components/file/edit_attachments_v1';
import { closeShopApi } from '@/views/openShopApply/services.js'
import {commonValidateRule} from '@/libs/rules_utils.js'
import { getsafe } from '@/libs/util.js'
import {VIcon} from 'vuetify/lib'
import bdsq from '@/image/bdsq.png'
import TooltipBZ from '@/views/blogger/records/components/TooltipBZ.vue'
const commonValidateRuleGo = commonValidateRule('必选')
const upload_format = ['image/jpeg', 'jpg', 'jpeg', 'png', 'docx', 'xlsx', 'xls', 'csv', 'excel', 'spreadsheetml.sheet', 'pdf']

function createParams() {
    return {
        close_reason: null,
        opening_shop_order_id: null,
        write_off: false,
        transfer_shop: null,
        principal_id: null,
        team_id: null,
        accomplish: false,
        bfiles: []
    }
}

export default {
    data() {
        return {
            show: false,
            saving: false,
            params: createParams()
        }
    },
    computed: {
        fields() {
            return [
             
                {
                    label: '申请理由',
                    key:'close_reason',
                    type: 'textareas_field',
                    // placeholder: '请补充此次需在法务盖章节点前付款的事项理由。',
                    rows: 4,
                    counter: 500,
                    required: true,
                    rules: [val => !!val || '必填', val => val && val.length <= 500 || '字数不能超过500'],
                    show: true,
                },
                {
                    label: '转移团队',
                    // type: 'checkbox',
                    type: 'radio_buttons',
                    key: 'transfer_shop',
                    row: true,
                    rules: [val => [true, false].includes(val) || '必填'],
                    items: [
                        {
                            value: true,
                            key: true,
                            label: '是',
                        },
                        {
                            value: false,
                            key: false,
                            label: '否',
                        },
                    ],
                    show: !this.params.write_off,
                },
                {
                    label: '团队',
                    type: 'team_select',
                    key: 'team_id',
                    required: true,
                    // cols: 3,
                    rules: [commonValidateRuleGo],
                    show: !this.params.write_off && this.params.transfer_shop
                },
                {
                    label: '店铺负责人',
                    key:'principal_id',
                    // initList: this.defaultApply,
                    out_params: {
                       //  formal: true,
                    },
                    type:'autocompletes_async_v1',
                    'item-value':'id',
                    'item-text':'account',
                    api: this.$util.api.customer_select_search,
                    required: true,
                    rules: [commonValidateRuleGo],
                    handle_data:({customers}) => {
                     return customers
                    },
                    show: !this.params.write_off && this.params.transfer_shop
                    // change:(data, target = {}) => {
                    //     _this.params.apply_user = target.account
                    //     if (!_this.params.id) {
                    //         _this.params.principal = target.account
                    //     }
                    // }
                },
                {
                    label: '',
                    key:'bfiles', 
                    show: true,
                },
                {
                    label: '是否完成【企业-账号管理】的相关操作',
                    type: 'checkbox',
                    key: 'accomplish',
                    show: this.params.write_off || this.params.transfer_shop,
                    scopedSlots: {
                        label: () => {
                            return <span>是否完成【企业-账号管理】的相关操作 
                                    <TooltipBZ 
                                        top
                                        minWidth={24}
                                        render={() => {
                                            return <div>
                                                <p>请上传【企业微信-法务-账号管理】操作完成的截图，例：</p>
                                                <img src={bdsq} 
                                                style="width: 900px;"
                                                ></img>
                                            </div>
                                        }}>
                                        <VIcon>mdi-help-circle-outline</VIcon>   
                                    </TooltipBZ>
                                </span>
                        }
                    }
                    // rules: [val=>!!val || '需完成【企业-账号管理】的相关操作才可提交'],
                },
            ].filter(i => i.show)
        },
    },
    methods: {
        edit({target, write_off}) {
            const params = createParams()
            params.opening_shop_order_id = target.id
            params.write_off = write_off
            this.show = true
            this.params = params
        },
        submit() {
            const params = JSON.parse(JSON.stringify(this.params))
            const bfiles = getsafe(params, 'bfiles', [])
            if (!params.transfer_shop) {
                delete params.principal_id
                delete params.team_id
            }
            if (bfiles.length === 0) {
                delete params.bfiles
            }
            if ((params.write_off || params.transfer_shop) && bfiles.length <= 0) {
                this.$Message.error('请上传附件！')
                return 
            }
           
            if (this.$refs.form.validate()) {
                if ((this.params.write_off || this.params.transfer_shop) && !params.accomplish) {
                    this.$vModal.error({
                        title: '提示',
                        content: '请先在【企业微信-账号管理】中完成相关操作后再提关闭店申请'
                    })
                    return 
                }
                this.saving = true
                closeShopApi(params).then(() => {
                    this.$emit('success')
                }).finally(() => {
                    this.saving = false
                })
            }
      
        }

    },
    render() {
        const _this = this
        return <VModal
            dynamicHeight
            heightRate={0.9}
            v-model={_this.show}
            title="闭店申请"
            loading={_this.saving}
            width={600}
            ref="modal"
            ok-text="提交"
            on={{
                ok: () => {
                    this.submit() 
                },
                cancel:() => {
                    this.show = false
                    _this.params = {}
                }
            }}
        >
           
            <VForm ref="form"
                v-model={_this.params}
                fields={_this.fields}
                scopedSlots={{
                    bfiles:({field} = {}) => {
                        return <div style="display:flex">
                        <p style="width:40px">
                            附件
                        </p>
                        <div style="flex:1">
                            <EditAttachments
                                files={_this.params.bfiles}
                                modelType="ClosingShopOrder"
                               // modelId={_this.params.id}
                                />
                                <FileUploader 
                                     format={upload_format}
                                    validateFile={(file) => {
                                        const a = /\.[0-9a-zA-Z]+$/.test(file.name)
                                        if (!a) {
                                          this.$vModal.warning({
                                              title:'提示',
                                              content:'文件格式错误，无法解析。建议上传如下类型：.xlsx、.pdf等带有后缀的'
                                          })
                                        }
                                        return a
                                    }}
                                    on={{
                                        uploaded: (bfile) => {
 
                                            _this.params.bfiles.push(bfile)
                                        }
                                    }}/>
                                <span class="color-error">为保证兼容性及文档可编辑性，请上传office系列的文档(Word, Excel, PPT)</span>
                        </div>
                    </div>
                    },
                }}
                />
        </VModal>
    }
}